import React, { useState } from "react";
import { galleryData } from "../Data";

export const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const showPrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + galleryData.length) % galleryData.length
    );
  };

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryData.length);
  };

  return (
    <>
      <div
        className="h-[20rem] bg-cover relative bg-center flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("./img/gallery.png")',
        }}
      >
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
          Gallery
        </h1>
      </div>
      <div className="max-w-screen-xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {galleryData.map((client, index) => (
            <div key={client.id} className="cursor-pointer">
              <img
                src={client.imageSrc}
                alt={client.name}
                onClick={() => openModal(index)}
                className="object-contain h-40 w-full border rounded-md shadow-sm hover:scale-105 transition-transform"
              />
            </div>
          ))}
        </div>

        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-2xl max-w-3xl w-full mx-4">
              <button
                onClick={closeModal}
                className="absolute top-2 right-3 text-gray-700 hover:text-red-500 text-2xl font-bold"
              >
                &times;
              </button>

              <img
                src={galleryData[currentIndex].imageSrc}
                alt={galleryData[currentIndex].name}
                className="mx-auto object-contain w-[90vw] max-w-[600px] h-[400px]"
              />

              <button
                onClick={showPrev}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10094;
              </button>
              <button
                onClick={showNext}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-black"
              >
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
